import {
	GET_BY_KEY, GET_TEXT_FROM, GET_TEXT, GET_TEXT_NO_QUESTION_MARK,
	GET_TISK_TEXT, GET_HINT, GET_ZKRATKA, POPIS_POLI, POPIS_OSTATNI, MENU, FORMULAR, CHYBOVE_HLASKY,
} from '../getterTypes';

function notFound(key) {
	// TODO: JM console.error(`Localization key "${key}" not found.`);

	return `??${key}`;
}

export const getters = {
	[GET_BY_KEY](state) {
		return (localizationType, key) => {
			if (typeof key === 'string' && state[localizationType] && state[localizationType][key]) {
				return state[localizationType][key];
			} return null;
		};
	},
	[GET_TEXT_NO_QUESTION_MARK](state, gettersParam) {
		return (key) => {
			let item = gettersParam[GET_BY_KEY](POPIS_POLI, key);
			if (item === null) { item = gettersParam[GET_BY_KEY](POPIS_OSTATNI, key); }
			if (item === null) { item = gettersParam[GET_BY_KEY](CHYBOVE_HLASKY, key); }
			return (item) ? item.Text : key;
		};
	},
	[GET_TEXT_FROM](state, gettersParam) {
		return (localizationType, key) => {
			const item = gettersParam[GET_BY_KEY](localizationType, key);
			const isText = (localizationType === MENU || localizationType === FORMULAR || !item);
			const itemText = (isText) ? item : item.Text;
			return (item) ? itemText : notFound(key);
		};
	},
	[GET_TEXT](state, gettersParam) {
		return (key) => {
			let item = gettersParam[GET_BY_KEY](POPIS_POLI, key);
			if (item === null) { item = gettersParam[GET_BY_KEY](POPIS_OSTATNI, key); }
			if (item === null) { item = gettersParam[GET_BY_KEY](CHYBOVE_HLASKY, key); }
			return (item) ? item.Text : notFound(key);
		};
	},
	[GET_TISK_TEXT](state, gettersParam) {
		return (key) => {
			const item = gettersParam[GET_BY_KEY](POPIS_POLI, key);
			return (item) ? item.TiskText : notFound(key);
		};
	},
	[GET_HINT](state, gettersParam) {
		return (key) => {
			let item = gettersParam[GET_BY_KEY](POPIS_POLI, key);
			if (item === null) { item = gettersParam[GET_BY_KEY](POPIS_OSTATNI, key); }
			return (item) ? item.TextHint : notFound(key);
		};
	},
	[GET_ZKRATKA](state, gettersParam) {
		return (key) => {
			const item = gettersParam[GET_BY_KEY](POPIS_POLI, key);
			return (item && item.TextZkratka) ? item.TextZkratka : notFound(key);
		};
	},
};
